import React from 'react'
import { Route, Switch } from 'react-router-dom'

import Landing from 'views/Home/Landing'
import ResetPasswordRoutes from './ResetPassword'
import SignupRoutes from './Signup'
import IdentityServerCallback from 'components/common/IdentityServerCallback'
import Login from 'views/Home/Login'

// eslint-disable-next-line react/display-name
export default ({ match }) => (
  <Switch>
    <Route path={`${match.path}login`} component={Login} />

    <Route path={`${match.path}signup`} component={SignupRoutes} />

    <Route path={`${match.path}change-password`} component={ResetPasswordRoutes} />
    <Route path={`${match.path}identity-server/callback`} component={IdentityServerCallback} />
    <Route path={match.path} component={Landing} />
  </Switch>
)
